import { RentalFilter } from "../RentalFilter";

export class RentalFilterResetHelper {
    private rentalFilterModule: RentalFilter;


    public init(rentalFilterModule: RentalFilter) {
        this.rentalFilterModule = rentalFilterModule;

        $('.rental__filter_reset-cat').on('click',
            () => {
                this.resetCatFilter(false);
                this.rentalFilterModule.updateFilterItems();
            });


        $('.rental__filter_reset-drpdwn').on('click',
            () => {
                this.resetDropdownFilters();
                this.rentalFilterModule.updateFilterItems();
            });

        $('.rental__filter_settings-reset').on('click',
            () => {
                this.resetAllFilters();
            });
    }

    resetAllFilters() {
        this.resetCatFilter(false);
        this.resetDropdownFilters();
        this.rentalFilterModule.updateFilterItems();
    }

    resetCatFilter(triggerChangeEvent: boolean) {
        this.rentalFilterModule.filterUpdateAllowed = false;

        const $elem = $('input[name=rental_landing__cat][value=null]');
        $elem.prop('checked', true);

        if (triggerChangeEvent) {
            $elem.trigger('change');
        }

        this.rentalFilterModule.filterUpdateAllowed = true;
    }

    resetDropdownFilters() {
        this.rentalFilterModule.filterUpdateAllowed = false;

        this.rentalFilterModule._durationDropDown.resetSelection();
        this.rentalFilterModule._locationDropDown.resetSelection();
        this.rentalFilterModule._dateDropDown.resetSelection();
        this.rentalFilterModule.datePicker.resetDateSelection();

        this.rentalFilterModule.filterUpdateAllowed = true;
    }
} 